
import { Vue, Component } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    Viewer,
  },
  name: 'OnsitePhotosDrawer',
})
export default class OnsitePhotosDrawer extends Vue {
  visible = false;

  shopImages: any[] = [];

  onClose() {
    this.visible = false;
  }

  init(val: any) {
    console.log(val);
    this.visible = true;
    this.shopImages = val;
  }
}

